unit Pranje;

interface

uses
  System.SysUtils, System.Variants, System.Classes, TerminalForm,
  Vcl.Graphics, Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WEBLib.DBCtrls, WEBLib.JSON, JS,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.Controls, WEBLib.ExtCtrls,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, WEBLib.Forms,
  XData.Web.Connection, WEBLib.SignatureCapture, Vcl.Grids, Web, System.DateUtils,
  XData.Web.Client;

type
  TfrmPranje = class(TTerminalForm)
    dsPranjePodrobno: TDataSource;
    wdsPranjePodrobno: TXDataWebDataSet;
    dsPranje: TDataSource;
    wdsPranje: TXDataWebDataSet;
    panInfo: TPanel;
    WebLabel2: TLabel;
    WebLabel4: TLabel;
    WebDBLabel1: TDBLabel;
    WebDBLabel3: TDBLabel;
    WebDBLabel5: TDBLabel;
    panPosode: TPanel;
    gridPodrobno: TDBGrid;
    panNotes: TPanel;
    WebLabel5: TLabel;
    memoNotes: TDBMemo;
    panNotesButtons: TGridPanel;
    btnOpomba1: TButton;
    btnOpomba2: TButton;
    btnOpomba3: TButton;
    btnDelNote: TButton;
    panFooter: TPanel;
    btnSave: TButton;
    btnCancel: TButton;
    btnNotes: TButton;
    btnAll: TButton;
    xwcSifranti: TXDataWebClient;
    wdsPranjeVozilo: TXDataWebEntityField;
    wdsPranjeLokacija: TXDataWebEntityField;
    wdsPranjeLokacijaStranka: TXDataWebEntityField;
    wdsPranjeLokacijaStrankaLokacije: TXDataWebDatasetField;
    wdsPranjeLokacijaStrankaId: TIntegerField;
    wdsPranjeLokacijaStrankaZunanjaOznaka: TIntegerField;
    wdsPranjeLokacijaStrankaAktivna: TBooleanField;
    wdsPranjeLokacijaStrankaObracun: TIntegerField;
    wdsPranjeLokacijaStrankaNaziv: TStringField;
    wdsPranjeLokacijaStrankaNaslov: TStringField;
    wdsPranjeLokacijaStrankaPosta: TStringField;
    wdsPranjeLokacijaStrankaKraj: TStringField;
    wdsPranjeLokacijaStrankaDavSt: TStringField;
    wdsPranjeLokacijaStrankaTel: TStringField;
    wdsPranjeLokacijaStrankaOpombe: TStringField;
    wdsPranjeLokacijaPosode: TXDataWebDatasetField;
    wdsPranjeLokacijaId: TIntegerField;
    wdsPranjeLokacijaAktivna: TBooleanField;
    wdsPranjeLokacijaNaziv: TStringField;
    wdsPranjeLokacijaOpombe: TStringField;
    wdsPranjeLokacijaLat: TFloatField;
    wdsPranjeLokacijaLon: TFloatField;
    wdsPranjeLokacijaAktivnaOd: TDateTimeField;
    wdsPranjeLokacijaAktivnaDo: TDateTimeField;
    wdsPranjeVoznik: TXDataWebEntityField;
    wdsPranjeVoznikVloga: TXDataWebEntityField;
    wdsPranjeVoznikVlogaId: TIntegerField;
    wdsPranjeVoznikVlogaOpis: TStringField;
    wdsPranjeVoznikId: TIntegerField;
    wdsPranjeVoznikUporabniskoIme: TStringField;
    wdsPranjeVoznikGeslo: TStringField;
    wdsPranjeVoznikPIN: TStringField;
    wdsPranjeVoznikIme: TStringField;
    wdsPranjeVoznikPriimek: TStringField;
    wdsPranjeVoznikAktiven: TBooleanField;
    wdsPranjeId: TIntegerField;
    wdsPranjeCasOdvoza: TDateTimeField;
    wdsPranjePodpisStranke: TBlobField;
    wdsPranjeOpombe: TStringField;
    wdsPranjeid2: TIntegerField;
    wdsPranjePotId: TIntegerField;
    wdsPranjePosode: TXDataWebDatasetField;
    wdsPranjeNaslov: TStringField;
    wdsPranjeLat: TFloatField;
    wdsPranjeLon: TFloatField;
    procedure btnCancelClick(Sender: TObject);
    procedure btnSaveClick(Sender: TObject);
    procedure wdsPranjeAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure wdsPranjeAfterOpen(DataSet: TDataSet);
    procedure FormCreate(Sender: TObject);
    procedure ApplyNote(Sender: TObject);
    procedure ClearNotes(Sender: TObject);
    procedure gridPodrobnoGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure btnNotesClick(Sender: TObject);
    procedure gridPodrobnoClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure wdsPranjePostError(DataSet: TDataSet; E: EDatabaseError; var Action: TDataAction);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
    FNalogId: integer; //Št odvoza, 0 za nove odvoze
    FAllowNegative: boolean;
    FSelRow: integer;
    procedure PripraviNalog(NalogId: integer);
    procedure PlusClick(event: TJSEvent);
    procedure MinusClick(event: TJSEvent);
    procedure ApplyTheme; reintroduce;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses Client.Core, Main, Client.Settings, Client.Constants;

procedure TfrmPranje.FormCreate(Sender: TObject);
begin
  inherited;

  FNalogId := modMain.NalogId;
  FAllowNegative := true;
  PripraviNalog(FNalogId);

  {$REGION 'Priprava gumbov za opombe'}
  btnOpomba1.Caption := modMain.AppSettings.NotePralec1;
  btnOpomba2.Caption := modMain.AppSettings.NotePralec2;
  btnOpomba3.Caption := modMain.AppSettings.NotePralec3;

  if Length(btnOpomba1.Caption) > 30 then
    btnOpomba1.Caption := Copy(btnOpomba1.Caption, 1, 30)+ '...';

  btnOpomba1.Visible := btnOpomba1.Caption <> '';
  btnOpomba2.Visible := btnOpomba2.Caption <> '';
  btnOpomba3.Visible := btnOpomba3.Caption <> '';
  {$ENDREGION}

  ApplyTheme;
end;

procedure TfrmPranje.PripraviNalog(NalogId: integer);
begin
  // 1. Pripravi novo pranje

  // Glava
  wdsPranje.Close;
  wdsPranje.QueryString := '$filter=Id eq '+FNalogId.ToString+' and Lokacija/Aktivna ne 0&$top=1&$expand=Lokacija,Lokacija/Stranka,Vozilo,Vozilo/TipVozila';
  modMain.Log('wdsPranje:' + wdsPranje.QueryString);
  wdsPranje.Load;

  // Podrobnosti
  wdsPranjePodrobno.Close;
  wdsPranjePodrobno.QueryString := '$filter=Nalog/Id eq '+FNalogId.ToString+'&$orderby=Id desc&$expand=Nalog,Posoda';
  modMain.Log('wdsPranjePodrobno:' + wdsPranjePodrobno.QueryString);
  wdsPranjePodrobno.Load;
end;

procedure TfrmPranje.wdsPranjeAfterOpen(DataSet: TDataSet);
var cas: TTime;
begin
  if wdsPranje.RecordCount>0 then begin
    wdsPranje.Edit;
  end else begin
    wdsPranje.Append;
    wdsPranje.FieldByName('Id').AsInteger := 0;
  end;

  cas := Time;   // Trenutni čas
  wdsPranje.FieldByName('CasPranja').AsDateTime := DateOf(modMain.IzbranDatum) + cas;
  modMain.Log('Čas pranja: '+wdsPranje.FieldByName('CasPranja').AsString);

  if modMain.VoziloMenjavaId>0 then begin
    wdsPranje.FieldByName('Vozilo').Value := modMain.VoziloMenjava;
  end else begin
    wdsPranje.FieldByName('Vozilo').Value := modMain.Vozilo;
  end;

  btnSave.Enabled := true;
  btnNotes.Enabled := true;
//  btnAll.Enabled := true;
end;

procedure TfrmPranje.wdsPranjePostError(DataSet: TDataSet; E: EDatabaseError; var Action: TDataAction);
begin
  modMain.log(E.Message);
end;

procedure TfrmPranje.WebFormShow(Sender: TObject);
begin
  inherited;

  gridPodrobno.RowHeights[0] := 70;
  gridPodrobno.ColWidths[0] := Round(frmMain.Width -10 - gridPodrobno.ColWidths[1] - gridPodrobno.ColWidths[2] - gridPodrobno.ColWidths[3])-2;
end;

procedure TfrmPranje.gridPodrobnoClickCell(Sender: TObject; ACol, ARow: Integer);
begin
  FSelRow := ACol;

  if ACol = 2 then begin
    FAllowNegative := not FAllowNegative;
  end;
end;

procedure TfrmPranje.PlusClick(event: TJSEvent);
begin
  FSelRow := StrToIntDef(TJSHTMLElement(event.target)['data'], FSelRow);

  wdsPranjePodrobno.RecNo := FSelRow+1;
  wdsPranjePodrobno.Edit;
  wdsPranjePodrobno.FieldByName('Kolicina').AsInteger := wdsPranjePodrobno.FieldByName('Kolicina').AsInteger + 1;
  wdsPranjePodrobno.Post;
end;

procedure TfrmPranje.MinusClick(event: TJSEvent);
begin
  FSelRow := StrToIntDef(TJSHTMLElement(event.target)['data'], FSelRow);

  wdsPranjePodrobno.RecNo := FSelRow+1;

  if (wdsPranjePodrobno.FieldByName('Kolicina').AsInteger > 0) or FAllowNegative then begin
    wdsPranjePodrobno.Edit;
    wdsPranjePodrobno.FieldByName('Kolicina').AsInteger := wdsPranjePodrobno.FieldByName('Kolicina').AsInteger - 1;
    wdsPranjePodrobno.Post;
  end;
end;

procedure TfrmPranje.gridPodrobnoGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
var el: TJSHTMLElement;
begin
  if ACol = 0 then
    Exit;

  if (ACol = 1) and (ARow >= 0) then begin
    el := TJSHTMLElement(document.createElement('INPUT'));
    el['type'] := 'BUTTON';
    el['value'] := '-';
    el['data'] := ARow.ToString;
    el.addEventListener('click',@MinusClick);
    el.style.setProperty('width','80px');
    el.style.setProperty('height','80px');
    el.style.setProperty('font-size','xxx-large');
//    el.innerHTML := '<i class="material-icons" style="font-size: 20px">close</i>';
    el.className := 'btn btn-xxl btn-danger';
    AElement.element.appendChild(el);
  end;

  if (ACol = gridPodrobno.Columns.Count-1 ) and (ARow >= 0) then begin
    el := TJSHTMLElement(document.createElement('INPUT'));
    el['type'] := 'BUTTON';
    el['value'] := '+';
    el['data'] := ARow.ToString;
    el.addEventListener('click',@PlusClick);
    el.style.setProperty('width','80px');
    el.style.setProperty('height','80px');
    el.style.setProperty('font-size','xxx-large');
//    el.innerHTML := '<i class="material-icons" style="font-size: 70px">add</i>';
    el.className := 'btn btn-xxl btn-success';
    AElement.element.appendChild(el);
  end;
end;

procedure TfrmPranje.ClearNotes(Sender: TObject);
begin
  memoNotes.Clear;
end;

procedure TfrmPranje.ApplyNote(Sender: TObject);
begin
  wdsPranje.Edit;

  if Sender = btnOpomba1 then
    wdsPranje.FieldByName('Opombe').AsString := modMain.AppSettings.NotePralec1;

  if Sender = btnOpomba2 then
    wdsPranje.FieldByName('Opombe').AsString := modMain.AppSettings.NotePralec2;

  if Sender = btnOpomba3 then
    wdsPranje.FieldByName('Opombe').AsString := modMain.AppSettings.NotePralec3;

  wdsPranje.Post;
end;

procedure TfrmPranje.ApplyTheme;
begin
  inherited;
end;

procedure TfrmPranje.btnCancelClick(Sender: TObject);
begin
  wdsPranje.Cancel;
  wdsPranjePodrobno.Cancel;
  frmMain.ShowNalogiPranje;
end;

procedure TfrmPranje.btnNotesClick(Sender: TObject);
begin
  panNotes.Visible := not panNotes.Visible;
end;

procedure TfrmPranje.btnSaveClick(Sender: TObject);
var OpombeSoNujne: boolean;
begin
  // Shrani samo wdsPranje, bo detail samodejno
  // https://support.tmssoftware.com/t/how-do-i-use-master-detail-when-a-new-record-is-being-inserted-in-master/19737/8
  if wdsPranjePodrobno.State in dsEditModes then
    wdsPranjePodrobno.Post;

  OpombeSoNujne := false;
  wdsPranjePodrobno.DisableControls;
  wdsPranjePodrobno.First;
  while not wdsPranjePodrobno.Eof do begin
    if wdsPranjePodrobno.FieldByName('Kolicina').AsInteger<0 then begin
      OpombeSoNujne := true;
    end;

    wdsPranjePodrobno.Next;
  end;
  wdsPranjePodrobno.EnableControls;

  if OpombeSoNujne and (wdsPranje.FieldByName('Opombe').AsString.Trim = '')  then begin
    ShowMessage('Negativno število opranih posod, prosim vpiši opombe!');
    exit;
  end;

  // Shrani na server
  wdsPranje.Edit;
  wdsPranje.Post;
  wdsPranje.ApplyUpdates;

  wdsPranjePodrobno.Edit;
  wdsPranjePodrobno.Post;
  wdsPranjePodrobno.ApplyUpdates;

  modMain.NastaviStatusPranje(wdsPranje.FieldByName('Id').AsInteger, Ord(npsZakljucen));
end;

procedure TfrmPranje.wdsPranjeAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
begin
  // Naslednja lokacija
  modMain.LokacijaLastRow := modMain.LokacijaLastRow + 1;

  frmMain.ShowNalogiPranje;
end;

procedure TfrmPranje.LoadDFMValues;
begin
  inherited LoadDFMValues;

  panInfo := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  WebDBLabel3 := TDBLabel.Create(Self);
  WebDBLabel5 := TDBLabel.Create(Self);
  panPosode := TPanel.Create(Self);
  gridPodrobno := TDBGrid.Create(Self);
  panNotes := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  memoNotes := TDBMemo.Create(Self);
  panNotesButtons := TGridPanel.Create(Self);
  btnOpomba1 := TButton.Create(Self);
  btnOpomba2 := TButton.Create(Self);
  btnOpomba3 := TButton.Create(Self);
  btnDelNote := TButton.Create(Self);
  panFooter := TPanel.Create(Self);
  btnSave := TButton.Create(Self);
  btnCancel := TButton.Create(Self);
  btnNotes := TButton.Create(Self);
  btnAll := TButton.Create(Self);
  dsPranjePodrobno := TDataSource.Create(Self);
  wdsPranjePodrobno := TXDataWebDataSet.Create(Self);
  dsPranje := TDataSource.Create(Self);
  wdsPranje := TXDataWebDataSet.Create(Self);
  wdsPranjeid2 := TIntegerField.Create(Self);
  wdsPranjeVozilo := TXDataWebEntityField.Create(Self);
  wdsPranjeLokacija := TXDataWebEntityField.Create(Self);
  wdsPranjeLokacijaStranka := TXDataWebEntityField.Create(Self);
  wdsPranjeLokacijaStrankaLokacije := TXDataWebDatasetField.Create(Self);
  wdsPranjeLokacijaStrankaId := TIntegerField.Create(Self);
  wdsPranjeLokacijaStrankaZunanjaOznaka := TIntegerField.Create(Self);
  wdsPranjeLokacijaStrankaAktivna := TBooleanField.Create(Self);
  wdsPranjeLokacijaStrankaObracun := TIntegerField.Create(Self);
  wdsPranjeLokacijaStrankaNaziv := TStringField.Create(Self);
  wdsPranjeLokacijaStrankaNaslov := TStringField.Create(Self);
  wdsPranjeLokacijaStrankaPosta := TStringField.Create(Self);
  wdsPranjeLokacijaStrankaKraj := TStringField.Create(Self);
  wdsPranjeLokacijaStrankaDavSt := TStringField.Create(Self);
  wdsPranjeLokacijaStrankaTel := TStringField.Create(Self);
  wdsPranjeLokacijaStrankaOpombe := TStringField.Create(Self);
  wdsPranjeLokacijaPosode := TXDataWebDatasetField.Create(Self);
  wdsPranjeLokacijaId := TIntegerField.Create(Self);
  wdsPranjeLokacijaAktivna := TBooleanField.Create(Self);
  wdsPranjeLokacijaNaziv := TStringField.Create(Self);
  wdsPranjeLokacijaOpombe := TStringField.Create(Self);
  wdsPranjeLokacijaLat := TFloatField.Create(Self);
  wdsPranjeLokacijaLon := TFloatField.Create(Self);
  wdsPranjeLokacijaAktivnaOd := TDateTimeField.Create(Self);
  wdsPranjeLokacijaAktivnaDo := TDateTimeField.Create(Self);
  wdsPranjeVoznik := TXDataWebEntityField.Create(Self);
  wdsPranjeVoznikVloga := TXDataWebEntityField.Create(Self);
  wdsPranjeVoznikVlogaId := TIntegerField.Create(Self);
  wdsPranjeVoznikVlogaOpis := TStringField.Create(Self);
  wdsPranjeVoznikId := TIntegerField.Create(Self);
  wdsPranjeVoznikUporabniskoIme := TStringField.Create(Self);
  wdsPranjeVoznikGeslo := TStringField.Create(Self);
  wdsPranjeVoznikPIN := TStringField.Create(Self);
  wdsPranjeVoznikIme := TStringField.Create(Self);
  wdsPranjeVoznikPriimek := TStringField.Create(Self);
  wdsPranjeVoznikAktiven := TBooleanField.Create(Self);
  wdsPranjeId := TIntegerField.Create(Self);
  wdsPranjeCasOdvoza := TDateTimeField.Create(Self);
  wdsPranjePodpisStranke := TBlobField.Create(Self);
  wdsPranjeOpombe := TStringField.Create(Self);
  wdsPranjePotId := TIntegerField.Create(Self);
  wdsPranjePosode := TXDataWebDatasetField.Create(Self);
  wdsPranjeNaslov := TStringField.Create(Self);
  wdsPranjeLat := TFloatField.Create(Self);
  wdsPranjeLon := TFloatField.Create(Self);
  xwcSifranti := TXDataWebClient.Create(Self);

  panInfo.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  WebDBLabel3.BeforeLoadDFMValues;
  WebDBLabel5.BeforeLoadDFMValues;
  panPosode.BeforeLoadDFMValues;
  gridPodrobno.BeforeLoadDFMValues;
  panNotes.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  memoNotes.BeforeLoadDFMValues;
  panNotesButtons.BeforeLoadDFMValues;
  btnOpomba1.BeforeLoadDFMValues;
  btnOpomba2.BeforeLoadDFMValues;
  btnOpomba3.BeforeLoadDFMValues;
  btnDelNote.BeforeLoadDFMValues;
  panFooter.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  btnNotes.BeforeLoadDFMValues;
  btnAll.BeforeLoadDFMValues;
  dsPranjePodrobno.BeforeLoadDFMValues;
  wdsPranjePodrobno.BeforeLoadDFMValues;
  dsPranje.BeforeLoadDFMValues;
  wdsPranje.BeforeLoadDFMValues;
  wdsPranjeid2.BeforeLoadDFMValues;
  wdsPranjeVozilo.BeforeLoadDFMValues;
  wdsPranjeLokacija.BeforeLoadDFMValues;
  wdsPranjeLokacijaStranka.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaLokacije.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaId.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaZunanjaOznaka.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaAktivna.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaObracun.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaNaziv.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaNaslov.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaPosta.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaKraj.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaDavSt.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaTel.BeforeLoadDFMValues;
  wdsPranjeLokacijaStrankaOpombe.BeforeLoadDFMValues;
  wdsPranjeLokacijaPosode.BeforeLoadDFMValues;
  wdsPranjeLokacijaId.BeforeLoadDFMValues;
  wdsPranjeLokacijaAktivna.BeforeLoadDFMValues;
  wdsPranjeLokacijaNaziv.BeforeLoadDFMValues;
  wdsPranjeLokacijaOpombe.BeforeLoadDFMValues;
  wdsPranjeLokacijaLat.BeforeLoadDFMValues;
  wdsPranjeLokacijaLon.BeforeLoadDFMValues;
  wdsPranjeLokacijaAktivnaOd.BeforeLoadDFMValues;
  wdsPranjeLokacijaAktivnaDo.BeforeLoadDFMValues;
  wdsPranjeVoznik.BeforeLoadDFMValues;
  wdsPranjeVoznikVloga.BeforeLoadDFMValues;
  wdsPranjeVoznikVlogaId.BeforeLoadDFMValues;
  wdsPranjeVoznikVlogaOpis.BeforeLoadDFMValues;
  wdsPranjeVoznikId.BeforeLoadDFMValues;
  wdsPranjeVoznikUporabniskoIme.BeforeLoadDFMValues;
  wdsPranjeVoznikGeslo.BeforeLoadDFMValues;
  wdsPranjeVoznikPIN.BeforeLoadDFMValues;
  wdsPranjeVoznikIme.BeforeLoadDFMValues;
  wdsPranjeVoznikPriimek.BeforeLoadDFMValues;
  wdsPranjeVoznikAktiven.BeforeLoadDFMValues;
  wdsPranjeId.BeforeLoadDFMValues;
  wdsPranjeCasOdvoza.BeforeLoadDFMValues;
  wdsPranjePodpisStranke.BeforeLoadDFMValues;
  wdsPranjeOpombe.BeforeLoadDFMValues;
  wdsPranjePotId.BeforeLoadDFMValues;
  wdsPranjePosode.BeforeLoadDFMValues;
  wdsPranjeNaslov.BeforeLoadDFMValues;
  wdsPranjeLat.BeforeLoadDFMValues;
  wdsPranjeLon.BeforeLoadDFMValues;
  xwcSifranti.BeforeLoadDFMValues;
  try
    Name := 'frmPranje';
    Left := 0;
    Top := 0;
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    SetEvent(Self, 'OnCreate', 'FormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    panInfo.SetParentComponent(Self);
    panInfo.Name := 'panInfo';
    panInfo.Left := 0;
    panInfo.Top := 0;
    panInfo.Width := 887;
    panInfo.Height := 115;
    panInfo.Align := alTop;
    panInfo.BorderStyle := bsNone;
    panInfo.ChildOrder := 3;
    panInfo.Color := clWhite;
    panInfo.TabOrder := 0;
    WebLabel2.SetParentComponent(panInfo);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 3;
    WebLabel2.Top := 43;
    WebLabel2.Width := 81;
    WebLabel2.Height := 25;
    WebLabel2.Caption := 'Lokacija:';
    WebLabel2.ElementClassName := 'h4';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -21;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(panInfo);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 3;
    WebLabel4.Top := 76;
    WebLabel4.Width := 86;
    WebLabel4.Height := 25;
    WebLabel4.Caption := 'Opombe:';
    WebLabel4.ElementClassName := 'h4';
    WebLabel4.ElementFont := efCSS;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -21;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebDBLabel1.SetParentComponent(panInfo);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 142;
    WebDBLabel1.Top := 43;
    WebDBLabel1.Width := 129;
    WebDBLabel1.Height := 25;
    WebDBLabel1.Caption := 'WebDBLabel1';
    WebDBLabel1.ElementClassName := 'h4';
    WebDBLabel1.ElementFont := efCSS;
    WebDBLabel1.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel1.Font.Color := clWindowText;
    WebDBLabel1.Font.Height := -21;
    WebDBLabel1.Font.Name := 'Tahoma';
    WebDBLabel1.Font.Style := [];
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.ParentFont := False;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'Naslov';
    WebDBLabel1.DataSource := dsPranje;
    WebDBLabel3.SetParentComponent(panInfo);
    WebDBLabel3.Name := 'WebDBLabel3';
    WebDBLabel3.Left := 142;
    WebDBLabel3.Top := 76;
    WebDBLabel3.Width := 129;
    WebDBLabel3.Height := 25;
    WebDBLabel3.Caption := 'WebDBLabel1';
    WebDBLabel3.ElementClassName := 'h4';
    WebDBLabel3.ElementFont := efCSS;
    WebDBLabel3.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel3.Font.Color := clWindowText;
    WebDBLabel3.Font.Height := -21;
    WebDBLabel3.Font.Name := 'Tahoma';
    WebDBLabel3.Font.Style := [];
    WebDBLabel3.HeightPercent := 100.000000000000000000;
    WebDBLabel3.ParentFont := False;
    WebDBLabel3.WidthPercent := 100.000000000000000000;
    WebDBLabel3.DataField := 'Opombe';
    WebDBLabel3.DataSource := dsPranje;
    WebDBLabel5.SetParentComponent(panInfo);
    WebDBLabel5.Name := 'WebDBLabel5';
    WebDBLabel5.Left := 3;
    WebDBLabel5.Top := -3;
    WebDBLabel5.Width := 143;
    WebDBLabel5.Height := 40;
    WebDBLabel5.Caption := 'lblStranka';
    WebDBLabel5.ElementClassName := 'h2';
    WebDBLabel5.ElementFont := efCSS;
    WebDBLabel5.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel5.Font.Color := clWindowText;
    WebDBLabel5.Font.Height := -33;
    WebDBLabel5.Font.Name := 'Tahoma';
    WebDBLabel5.Font.Style := [];
    WebDBLabel5.HeightPercent := 100.000000000000000000;
    WebDBLabel5.ParentFont := False;
    WebDBLabel5.WidthPercent := 100.000000000000000000;
    WebDBLabel5.DataField := 'Lokacija.Stranka.Naziv';
    WebDBLabel5.DataSource := dsPranje;
    panPosode.SetParentComponent(Self);
    panPosode.Name := 'panPosode';
    panPosode.Left := 0;
    panPosode.Top := 115;
    panPosode.Width := 887;
    panPosode.Height := 411;
    panPosode.Align := alClient;
    panPosode.BorderStyle := bsNone;
    panPosode.ChildOrder := 3;
    panPosode.Color := clWhite;
    panPosode.TabOrder := 1;
    gridPodrobno.SetParentComponent(panPosode);
    gridPodrobno.Name := 'gridPodrobno';
    gridPodrobno.Left := 0;
    gridPodrobno.Top := 0;
    gridPodrobno.Width := 887;
    gridPodrobno.Height := 411;
    gridPodrobno.Align := alClient;
    gridPodrobno.Color := clWhite;
    gridPodrobno.Columns.Clear;
    with gridPodrobno.Columns.Add do
    begin
      DataField := 'Posoda.Opis';
      Title := 'Posoda';
      Width := 380;
    end;
    with gridPodrobno.Columns.Add do
    begin
      Editor := geNone;
      Width := 80;
    end;
    with gridPodrobno.Columns.Add do
    begin
      Alignment := taCenter;
      ElementClassName := 'text-center';
      DataField := 'Kolicina';
      Editor := geNone;
      Title := 'Kol.';
      Width := 70;
    end;
    with gridPodrobno.Columns.Add do
    begin
      Editor := geNone;
      Width := 80;
    end;
    gridPodrobno.DataSource := dsPranjePodrobno;
    gridPodrobno.ElementFont := efCSS;
    gridPodrobno.ElementClassName := 'display-1';
    gridPodrobno.FixedFont.Charset := DEFAULT_CHARSET;
    gridPodrobno.FixedFont.Color := clWindowText;
    gridPodrobno.FixedFont.Height := -12;
    gridPodrobno.FixedFont.Name := 'Segoe UI';
    gridPodrobno.FixedFont.Style := [];
    gridPodrobno.FixedCols := 0;
    gridPodrobno.FixedRows := 0;
    gridPodrobno.Font.Charset := DEFAULT_CHARSET;
    gridPodrobno.Font.Color := clWindowText;
    gridPodrobno.Font.Height := -80;
    gridPodrobno.Font.Name := 'Tahoma';
    gridPodrobno.Font.Style := [];
    gridPodrobno.Options := [];
    gridPodrobno.ParentFont := False;
    gridPodrobno.TabOrder := 0;
    gridPodrobno.HeightPercent := 100.000000000000000000;
    gridPodrobno.ShowIndicator := False;
    gridPodrobno.WidthPercent := 100.000000000000000000;
    SetEvent(gridPodrobno, Self, 'OnClickCell', 'gridPodrobnoClickCell');
    SetEvent(gridPodrobno, Self, 'OnGetCellChildren', 'gridPodrobnoGetCellChildren');
    gridPodrobno.ColWidths[0] := 380;
    gridPodrobno.ColWidths[1] := 80;
    gridPodrobno.ColWidths[2] := 70;
    gridPodrobno.ColWidths[3] := 80;
    panNotes.SetParentComponent(Self);
    panNotes.Name := 'panNotes';
    panNotes.Left := 0;
    panNotes.Top := 526;
    panNotes.Width := 887;
    panNotes.Height := 299;
    panNotes.Align := alBottom;
    panNotes.Caption := 'panNotes';
    panNotes.ChildOrder := 8;
    panNotes.TabOrder := 2;
    panNotes.Visible := False;
    WebLabel5.SetParentComponent(panNotes);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 0;
    WebLabel5.Width := 887;
    WebLabel5.Height := 33;
    WebLabel5.Align := alTop;
    WebLabel5.Caption := 'Opombe';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -27;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    memoNotes.SetParentComponent(panNotes);
    memoNotes.Name := 'memoNotes';
    memoNotes.Left := 0;
    memoNotes.Top := 33;
    memoNotes.Width := 887;
    memoNotes.Height := 166;
    memoNotes.Align := alClient;
    memoNotes.Font.Charset := DEFAULT_CHARSET;
    memoNotes.Font.Color := clWindowText;
    memoNotes.Font.Height := -27;
    memoNotes.Font.Name := 'Tahoma';
    memoNotes.Font.Style := [];
    memoNotes.HeightPercent := 100.000000000000000000;
    memoNotes.Lines.BeginUpdate;
    try
      memoNotes.Lines.Clear;
      memoNotes.Lines.Add('memoNotes');
    finally
      memoNotes.Lines.EndUpdate;
    end;
    memoNotes.ParentFont := False;
    memoNotes.SelLength := 0;
    memoNotes.SelStart := 0;
    memoNotes.WidthPercent := 100.000000000000000000;
    memoNotes.DataField := 'Opombe';
    memoNotes.DataSource := dsPranje;
    panNotesButtons.SetParentComponent(panNotes);
    panNotesButtons.Name := 'panNotesButtons';
    panNotesButtons.Left := 0;
    panNotesButtons.Top := 199;
    panNotesButtons.Width := 887;
    panNotesButtons.Height := 100;
    panNotesButtons.Align := alBottom;
    panNotesButtons.ChildOrder := 4;
    panNotesButtons.ColumnCollection.Clear;
    with panNotesButtons.ColumnCollection.Add do
    begin
      MarginLeft := 3;
      MarginRight := 3;
      Value := 33;
    end;
    with panNotesButtons.ColumnCollection.Add do
    begin
      MarginLeft := 3;
      MarginRight := 3;
      Value := 33;
    end;
    with panNotesButtons.ColumnCollection.Add do
    begin
      MarginLeft := 3;
      MarginRight := 3;
      Value := 33;
    end;
    panNotesButtons.ControlCollection.Clear;
    with panNotesButtons.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := btnOpomba1;
    end;
    with panNotesButtons.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := btnOpomba2;
    end;
    with panNotesButtons.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := btnOpomba3;
    end;
    panNotesButtons.Color := clWhite;
    panNotesButtons.GridLineColor := clBlack;
    panNotesButtons.RowCollection.Clear;
    with panNotesButtons.RowCollection.Add do
    begin
      Value := 100;
    end;
    btnOpomba1.SetParentComponent(panNotesButtons);
    btnOpomba1.Name := 'btnOpomba1';
    btnOpomba1.AlignWithMargins := True;
    btnOpomba1.Left := 5;
    btnOpomba1.Top := 2;
    btnOpomba1.Width := 283;
    btnOpomba1.Height := 96;
    btnOpomba1.Align := alClient;
    btnOpomba1.Caption := 'Opomba 1';
    btnOpomba1.ChildOrder := 2;
    btnOpomba1.ElementClassName := 'btn btn-xxl btn-primary shadow d-inline-block text-truncate';
    btnOpomba1.ElementFont := efCSS;
    btnOpomba1.HeightPercent := 100.000000000000000000;
    btnOpomba1.WidthPercent := 100.000000000000000000;
    SetEvent(btnOpomba1, Self, 'OnClick', 'ApplyNote');
    btnOpomba2.SetParentComponent(panNotesButtons);
    btnOpomba2.Name := 'btnOpomba2';
    btnOpomba2.AlignWithMargins := True;
    btnOpomba2.Left := 298;
    btnOpomba2.Top := 2;
    btnOpomba2.Width := 283;
    btnOpomba2.Height := 96;
    btnOpomba2.Align := alClient;
    btnOpomba2.Caption := 'Opomba 2';
    btnOpomba2.ChildOrder := 2;
    btnOpomba2.ElementClassName := 'btn btn-xxl btn-primary shadow';
    btnOpomba2.ElementFont := efCSS;
    btnOpomba2.HeightPercent := 100.000000000000000000;
    btnOpomba2.WidthPercent := 100.000000000000000000;
    SetEvent(btnOpomba2, Self, 'OnClick', 'ApplyNote');
    btnOpomba3.SetParentComponent(panNotesButtons);
    btnOpomba3.Name := 'btnOpomba3';
    btnOpomba3.AlignWithMargins := True;
    btnOpomba3.Left := 591;
    btnOpomba3.Top := 2;
    btnOpomba3.Width := 283;
    btnOpomba3.Height := 96;
    btnOpomba3.Align := alClient;
    btnOpomba3.Caption := 'Opomba 3';
    btnOpomba3.ChildOrder := 2;
    btnOpomba3.ElementClassName := 'btn btn-xxl btn-primary shadow';
    btnOpomba3.ElementFont := efCSS;
    btnOpomba3.HeightPercent := 100.000000000000000000;
    btnOpomba3.WidthPercent := 100.000000000000000000;
    SetEvent(btnOpomba3, Self, 'OnClick', 'ApplyNote');
    btnDelNote.SetParentComponent(panNotes);
    btnDelNote.Name := 'btnDelNote';
    btnDelNote.AlignWithMargins := True;
    btnDelNote.Left := 812;
    btnDelNote.Top := 39;
    btnDelNote.Width := 59;
    btnDelNote.Height := 62;
    btnDelNote.Margins.Right := 10;
    btnDelNote.Anchors := [akTop,akRight];
    btnDelNote.Caption := '<i class="material-icons">backspace</i>';
    btnDelNote.ChildOrder := 2;
    btnDelNote.ElementClassName := 'btn btn-xxl btn-primary shadow';
    btnDelNote.ElementFont := efCSS;
    btnDelNote.HeightPercent := 100.000000000000000000;
    btnDelNote.WidthPercent := 100.000000000000000000;
    SetEvent(btnDelNote, Self, 'OnClick', 'ClearNotes');
    panFooter.SetParentComponent(Self);
    panFooter.Name := 'panFooter';
    panFooter.Left := 0;
    panFooter.Top := 825;
    panFooter.Width := 887;
    panFooter.Height := 120;
    panFooter.Align := alBottom;
    panFooter.BorderColor := clNone;
    panFooter.BorderStyle := bsNone;
    panFooter.ChildOrder := 3;
    panFooter.Color := clWhite;
    panFooter.Padding.Top := 4;
    panFooter.TabOrder := 3;
    btnSave.SetParentComponent(panFooter);
    btnSave.Name := 'btnSave';
    btnSave.AlignWithMargins := True;
    btnSave.Left := 712;
    btnSave.Top := 7;
    btnSave.Width := 165;
    btnSave.Height := 110;
    btnSave.Margins.Right := 10;
    btnSave.Align := alRight;
    btnSave.Caption := '<i class="material-icons" style="font-size:40px;">done</i>';
    btnSave.ElementClassName := 'btn btn-success';
    btnSave.ElementFont := efCSS;
    btnSave.Enabled := False;
    btnSave.HeightPercent := 100.000000000000000000;
    btnSave.WidthPercent := 100.000000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    btnCancel.SetParentComponent(panFooter);
    btnCancel.Name := 'btnCancel';
    btnCancel.AlignWithMargins := True;
    btnCancel.Left := 10;
    btnCancel.Top := 7;
    btnCancel.Width := 100;
    btnCancel.Height := 110;
    btnCancel.Margins.Left := 10;
    btnCancel.Margins.Right := 10;
    btnCancel.Align := alLeft;
    btnCancel.Caption := '<i class="material-icons" style="font-size:40px;">close</i>';
    btnCancel.ChildOrder := 1;
    btnCancel.ElementClassName := 'btn btn-danger';
    btnCancel.ElementFont := efCSS;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    btnNotes.SetParentComponent(panFooter);
    btnNotes.Name := 'btnNotes';
    btnNotes.AlignWithMargins := True;
    btnNotes.Left := 599;
    btnNotes.Top := 7;
    btnNotes.Width := 100;
    btnNotes.Height := 110;
    btnNotes.Margins.Right := 10;
    btnNotes.Align := alRight;
    btnNotes.Caption := '<i class="material-icons">notes</i>';
    btnNotes.ElementClassName := 'btn btn-primary';
    btnNotes.ElementFont := efCSS;
    btnNotes.HeightPercent := 100.000000000000000000;
    btnNotes.WidthPercent := 100.000000000000000000;
    SetEvent(btnNotes, Self, 'OnClick', 'btnNotesClick');
    btnAll.SetParentComponent(panFooter);
    btnAll.Name := 'btnAll';
    btnAll.AlignWithMargins := True;
    btnAll.Left := 486;
    btnAll.Top := 7;
    btnAll.Width := 100;
    btnAll.Height := 110;
    btnAll.Margins.Right := 10;
    btnAll.Align := alRight;
    btnAll.Caption := '<i class="material-icons">check-all</i>';
    btnAll.ElementClassName := 'btn btn-primary';
    btnAll.ElementFont := efCSS;
    btnAll.HeightPercent := 100.000000000000000000;
    btnAll.Visible := False;
    btnAll.WidthPercent := 100.000000000000000000;
    dsPranjePodrobno.SetParentComponent(Self);
    dsPranjePodrobno.Name := 'dsPranjePodrobno';
    dsPranjePodrobno.DataSet := wdsPranjePodrobno;
    dsPranjePodrobno.Left := 592;
    dsPranjePodrobno.Top := 104;
    wdsPranjePodrobno.SetParentComponent(Self);
    wdsPranjePodrobno.Name := 'wdsPranjePodrobno';
    SetEvent(wdsPranjePodrobno, Self, 'OnEditError', 'wdsPranjePostError');
    SetEvent(wdsPranjePodrobno, Self, 'OnPostError', 'wdsPranjePostError');
    wdsPranjePodrobno.EntitySetName := 'NalogPranjePodrobno';
    wdsPranjePodrobno.Connection := modMain.connServer;
    wdsPranjePodrobno.SubpropsDepth := 1;
    wdsPranjePodrobno.Left := 592;
    wdsPranjePodrobno.Top := 48;
    dsPranje.SetParentComponent(Self);
    dsPranje.Name := 'dsPranje';
    dsPranje.DataSet := wdsPranje;
    dsPranje.Left := 496;
    dsPranje.Top := 104;
    wdsPranje.SetParentComponent(Self);
    wdsPranje.Name := 'wdsPranje';
    wdsPranje.AfterApplyUpdates := wdsPranjeAfterApplyUpdates;
    wdsPranje.AfterOpen := wdsPranjeAfterOpen;
    SetEvent(wdsPranje, Self, 'OnEditError', 'wdsPranjePostError');
    SetEvent(wdsPranje, Self, 'OnPostError', 'wdsPranjePostError');
    wdsPranje.EntitySetName := 'NalogPranje';
    wdsPranje.Connection := modMain.connServer;
    wdsPranje.SubpropsDepth := 1;
    wdsPranje.Left := 496;
    wdsPranje.Top := 48;
    wdsPranjeid2.SetParentComponent(wdsPranje);
    wdsPranjeid2.Name := 'wdsPranjeid2';
    wdsPranjeid2.FieldName := '$id';
    wdsPranjeVozilo.SetParentComponent(wdsPranje);
    wdsPranjeVozilo.Name := 'wdsPranjeVozilo';
    wdsPranjeVozilo.FieldName := 'Vozilo';
    wdsPranjeVozilo.Required := True;
    wdsPranjeLokacija.SetParentComponent(wdsPranje);
    wdsPranjeLokacija.Name := 'wdsPranjeLokacija';
    wdsPranjeLokacija.FieldName := 'Lokacija';
    wdsPranjeLokacijaStranka.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStranka.Name := 'wdsPranjeLokacijaStranka';
    wdsPranjeLokacijaStranka.FieldName := 'Lokacija.Stranka';
    wdsPranjeLokacijaStrankaLokacije.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaLokacije.Name := 'wdsPranjeLokacijaStrankaLokacije';
    wdsPranjeLokacijaStrankaLokacije.FieldName := 'Lokacija.Stranka.Lokacije';
    wdsPranjeLokacijaStrankaLokacije.ReadOnly := True;
    wdsPranjeLokacijaStrankaId.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaId.Name := 'wdsPranjeLokacijaStrankaId';
    wdsPranjeLokacijaStrankaId.FieldName := 'Lokacija.Stranka.Id';
    wdsPranjeLokacijaStrankaZunanjaOznaka.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaZunanjaOznaka.Name := 'wdsPranjeLokacijaStrankaZunanjaOznaka';
    wdsPranjeLokacijaStrankaZunanjaOznaka.FieldName := 'Lokacija.Stranka.ZunanjaOznaka';
    wdsPranjeLokacijaStrankaAktivna.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaAktivna.Name := 'wdsPranjeLokacijaStrankaAktivna';
    wdsPranjeLokacijaStrankaAktivna.FieldName := 'Lokacija.Stranka.Aktivna';
    wdsPranjeLokacijaStrankaObracun.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaObracun.Name := 'wdsPranjeLokacijaStrankaObracun';
    wdsPranjeLokacijaStrankaObracun.FieldName := 'Lokacija.Stranka.Obracun';
    wdsPranjeLokacijaStrankaNaziv.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaNaziv.Name := 'wdsPranjeLokacijaStrankaNaziv';
    wdsPranjeLokacijaStrankaNaziv.FieldName := 'Lokacija.Stranka.Naziv';
    wdsPranjeLokacijaStrankaNaziv.Size := 50;
    wdsPranjeLokacijaStrankaNaslov.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaNaslov.Name := 'wdsPranjeLokacijaStrankaNaslov';
    wdsPranjeLokacijaStrankaNaslov.FieldName := 'Lokacija.Stranka.Naslov';
    wdsPranjeLokacijaStrankaNaslov.Size := 50;
    wdsPranjeLokacijaStrankaPosta.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaPosta.Name := 'wdsPranjeLokacijaStrankaPosta';
    wdsPranjeLokacijaStrankaPosta.FieldName := 'Lokacija.Stranka.Posta';
    wdsPranjeLokacijaStrankaPosta.Size := 15;
    wdsPranjeLokacijaStrankaKraj.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaKraj.Name := 'wdsPranjeLokacijaStrankaKraj';
    wdsPranjeLokacijaStrankaKraj.FieldName := 'Lokacija.Stranka.Kraj';
    wdsPranjeLokacijaStrankaKraj.Size := 50;
    wdsPranjeLokacijaStrankaDavSt.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaDavSt.Name := 'wdsPranjeLokacijaStrankaDavSt';
    wdsPranjeLokacijaStrankaDavSt.FieldName := 'Lokacija.Stranka.DavSt';
    wdsPranjeLokacijaStrankaDavSt.Size := 15;
    wdsPranjeLokacijaStrankaTel.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaTel.Name := 'wdsPranjeLokacijaStrankaTel';
    wdsPranjeLokacijaStrankaTel.FieldName := 'Lokacija.Stranka.Tel';
    wdsPranjeLokacijaStrankaOpombe.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaStrankaOpombe.Name := 'wdsPranjeLokacijaStrankaOpombe';
    wdsPranjeLokacijaStrankaOpombe.FieldName := 'Lokacija.Stranka.Opombe';
    wdsPranjeLokacijaStrankaOpombe.Size := 250;
    wdsPranjeLokacijaPosode.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaPosode.Name := 'wdsPranjeLokacijaPosode';
    wdsPranjeLokacijaPosode.FieldName := 'Lokacija.Posode';
    wdsPranjeLokacijaPosode.ReadOnly := True;
    wdsPranjeLokacijaId.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaId.Name := 'wdsPranjeLokacijaId';
    wdsPranjeLokacijaId.FieldName := 'Lokacija.Id';
    wdsPranjeLokacijaAktivna.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaAktivna.Name := 'wdsPranjeLokacijaAktivna';
    wdsPranjeLokacijaAktivna.FieldName := 'Lokacija.Aktivna';
    wdsPranjeLokacijaNaziv.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaNaziv.Name := 'wdsPranjeLokacijaNaziv';
    wdsPranjeLokacijaNaziv.FieldName := 'Lokacija.Naziv';
    wdsPranjeLokacijaNaziv.Size := 250;
    wdsPranjeLokacijaOpombe.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaOpombe.Name := 'wdsPranjeLokacijaOpombe';
    wdsPranjeLokacijaOpombe.FieldName := 'Lokacija.Opombe';
    wdsPranjeLokacijaOpombe.Size := 250;
    wdsPranjeLokacijaLat.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaLat.Name := 'wdsPranjeLokacijaLat';
    wdsPranjeLokacijaLat.FieldName := 'Lokacija.Lat';
    wdsPranjeLokacijaLon.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaLon.Name := 'wdsPranjeLokacijaLon';
    wdsPranjeLokacijaLon.FieldName := 'Lokacija.Lon';
    wdsPranjeLokacijaAktivnaOd.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaAktivnaOd.Name := 'wdsPranjeLokacijaAktivnaOd';
    wdsPranjeLokacijaAktivnaOd.FieldName := 'Lokacija.AktivnaOd';
    wdsPranjeLokacijaAktivnaDo.SetParentComponent(wdsPranje);
    wdsPranjeLokacijaAktivnaDo.Name := 'wdsPranjeLokacijaAktivnaDo';
    wdsPranjeLokacijaAktivnaDo.FieldName := 'Lokacija.AktivnaDo';
    wdsPranjeVoznik.SetParentComponent(wdsPranje);
    wdsPranjeVoznik.Name := 'wdsPranjeVoznik';
    wdsPranjeVoznik.FieldName := 'Voznik';
    wdsPranjeVoznikVloga.SetParentComponent(wdsPranje);
    wdsPranjeVoznikVloga.Name := 'wdsPranjeVoznikVloga';
    wdsPranjeVoznikVloga.FieldName := 'Voznik.Vloga';
    wdsPranjeVoznikVlogaId.SetParentComponent(wdsPranje);
    wdsPranjeVoznikVlogaId.Name := 'wdsPranjeVoznikVlogaId';
    wdsPranjeVoznikVlogaId.FieldName := 'Voznik.Vloga.Id';
    wdsPranjeVoznikVlogaOpis.SetParentComponent(wdsPranje);
    wdsPranjeVoznikVlogaOpis.Name := 'wdsPranjeVoznikVlogaOpis';
    wdsPranjeVoznikVlogaOpis.FieldName := 'Voznik.Vloga.Opis';
    wdsPranjeVoznikVlogaOpis.Size := 50;
    wdsPranjeVoznikId.SetParentComponent(wdsPranje);
    wdsPranjeVoznikId.Name := 'wdsPranjeVoznikId';
    wdsPranjeVoznikId.FieldName := 'Voznik.Id';
    wdsPranjeVoznikUporabniskoIme.SetParentComponent(wdsPranje);
    wdsPranjeVoznikUporabniskoIme.Name := 'wdsPranjeVoznikUporabniskoIme';
    wdsPranjeVoznikUporabniskoIme.FieldName := 'Voznik.UporabniskoIme';
    wdsPranjeVoznikUporabniskoIme.Size := 50;
    wdsPranjeVoznikGeslo.SetParentComponent(wdsPranje);
    wdsPranjeVoznikGeslo.Name := 'wdsPranjeVoznikGeslo';
    wdsPranjeVoznikGeslo.FieldName := 'Voznik.Geslo';
    wdsPranjeVoznikGeslo.Size := 50;
    wdsPranjeVoznikPIN.SetParentComponent(wdsPranje);
    wdsPranjeVoznikPIN.Name := 'wdsPranjeVoznikPIN';
    wdsPranjeVoznikPIN.FieldName := 'Voznik.PIN';
    wdsPranjeVoznikPIN.Size := 10;
    wdsPranjeVoznikIme.SetParentComponent(wdsPranje);
    wdsPranjeVoznikIme.Name := 'wdsPranjeVoznikIme';
    wdsPranjeVoznikIme.FieldName := 'Voznik.Ime';
    wdsPranjeVoznikIme.Size := 50;
    wdsPranjeVoznikPriimek.SetParentComponent(wdsPranje);
    wdsPranjeVoznikPriimek.Name := 'wdsPranjeVoznikPriimek';
    wdsPranjeVoznikPriimek.FieldName := 'Voznik.Priimek';
    wdsPranjeVoznikPriimek.Size := 50;
    wdsPranjeVoznikAktiven.SetParentComponent(wdsPranje);
    wdsPranjeVoznikAktiven.Name := 'wdsPranjeVoznikAktiven';
    wdsPranjeVoznikAktiven.FieldName := 'Voznik.Aktiven';
    wdsPranjeId.SetParentComponent(wdsPranje);
    wdsPranjeId.Name := 'wdsPranjeId';
    wdsPranjeId.FieldName := 'Id';
    wdsPranjeId.Required := True;
    wdsPranjeCasOdvoza.SetParentComponent(wdsPranje);
    wdsPranjeCasOdvoza.Name := 'wdsPranjeCasOdvoza';
    wdsPranjeCasOdvoza.FieldName := 'CasPranja';
    wdsPranjePodpisStranke.SetParentComponent(wdsPranje);
    wdsPranjePodpisStranke.Name := 'wdsPranjePodpisStranke';
    wdsPranjePodpisStranke.FieldName := 'PodpisStranke';
    wdsPranjeOpombe.SetParentComponent(wdsPranje);
    wdsPranjeOpombe.Name := 'wdsPranjeOpombe';
    wdsPranjeOpombe.FieldName := 'Opombe';
    wdsPranjeOpombe.Size := 50;
    wdsPranjePotId.SetParentComponent(wdsPranje);
    wdsPranjePotId.Name := 'wdsPranjePotId';
    wdsPranjePotId.FieldName := 'PotId';
    wdsPranjePosode.SetParentComponent(wdsPranje);
    wdsPranjePosode.Name := 'wdsPranjePosode';
    wdsPranjePosode.FieldName := 'Posode';
    wdsPranjePosode.ReadOnly := True;
    wdsPranjeNaslov.SetParentComponent(wdsPranje);
    wdsPranjeNaslov.Name := 'wdsPranjeNaslov';
    wdsPranjeNaslov.FieldName := 'Naslov';
    wdsPranjeNaslov.Size := 50;
    wdsPranjeLat.SetParentComponent(wdsPranje);
    wdsPranjeLat.Name := 'wdsPranjeLat';
    wdsPranjeLat.FieldName := 'Lat';
    wdsPranjeLon.SetParentComponent(wdsPranje);
    wdsPranjeLon.Name := 'wdsPranjeLon';
    wdsPranjeLon.FieldName := 'Lon';
    xwcSifranti.SetParentComponent(Self);
    xwcSifranti.Name := 'xwcSifranti';
    xwcSifranti.Connection := modMain.connServer;
    xwcSifranti.Left := 816;
    xwcSifranti.Top := 48;
  finally
    panInfo.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    WebDBLabel3.AfterLoadDFMValues;
    WebDBLabel5.AfterLoadDFMValues;
    panPosode.AfterLoadDFMValues;
    gridPodrobno.AfterLoadDFMValues;
    panNotes.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    memoNotes.AfterLoadDFMValues;
    panNotesButtons.AfterLoadDFMValues;
    btnOpomba1.AfterLoadDFMValues;
    btnOpomba2.AfterLoadDFMValues;
    btnOpomba3.AfterLoadDFMValues;
    btnDelNote.AfterLoadDFMValues;
    panFooter.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    btnNotes.AfterLoadDFMValues;
    btnAll.AfterLoadDFMValues;
    dsPranjePodrobno.AfterLoadDFMValues;
    wdsPranjePodrobno.AfterLoadDFMValues;
    dsPranje.AfterLoadDFMValues;
    wdsPranje.AfterLoadDFMValues;
    wdsPranjeid2.AfterLoadDFMValues;
    wdsPranjeVozilo.AfterLoadDFMValues;
    wdsPranjeLokacija.AfterLoadDFMValues;
    wdsPranjeLokacijaStranka.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaLokacije.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaId.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaZunanjaOznaka.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaAktivna.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaObracun.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaNaziv.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaNaslov.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaPosta.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaKraj.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaDavSt.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaTel.AfterLoadDFMValues;
    wdsPranjeLokacijaStrankaOpombe.AfterLoadDFMValues;
    wdsPranjeLokacijaPosode.AfterLoadDFMValues;
    wdsPranjeLokacijaId.AfterLoadDFMValues;
    wdsPranjeLokacijaAktivna.AfterLoadDFMValues;
    wdsPranjeLokacijaNaziv.AfterLoadDFMValues;
    wdsPranjeLokacijaOpombe.AfterLoadDFMValues;
    wdsPranjeLokacijaLat.AfterLoadDFMValues;
    wdsPranjeLokacijaLon.AfterLoadDFMValues;
    wdsPranjeLokacijaAktivnaOd.AfterLoadDFMValues;
    wdsPranjeLokacijaAktivnaDo.AfterLoadDFMValues;
    wdsPranjeVoznik.AfterLoadDFMValues;
    wdsPranjeVoznikVloga.AfterLoadDFMValues;
    wdsPranjeVoznikVlogaId.AfterLoadDFMValues;
    wdsPranjeVoznikVlogaOpis.AfterLoadDFMValues;
    wdsPranjeVoznikId.AfterLoadDFMValues;
    wdsPranjeVoznikUporabniskoIme.AfterLoadDFMValues;
    wdsPranjeVoznikGeslo.AfterLoadDFMValues;
    wdsPranjeVoznikPIN.AfterLoadDFMValues;
    wdsPranjeVoznikIme.AfterLoadDFMValues;
    wdsPranjeVoznikPriimek.AfterLoadDFMValues;
    wdsPranjeVoznikAktiven.AfterLoadDFMValues;
    wdsPranjeId.AfterLoadDFMValues;
    wdsPranjeCasOdvoza.AfterLoadDFMValues;
    wdsPranjePodpisStranke.AfterLoadDFMValues;
    wdsPranjeOpombe.AfterLoadDFMValues;
    wdsPranjePotId.AfterLoadDFMValues;
    wdsPranjePosode.AfterLoadDFMValues;
    wdsPranjeNaslov.AfterLoadDFMValues;
    wdsPranjeLat.AfterLoadDFMValues;
    wdsPranjeLon.AfterLoadDFMValues;
    xwcSifranti.AfterLoadDFMValues;
  end;
end;

end.
